var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-input-wrapper" },
    [
      _c("h6", { staticClass: "title" }, [_vm._v(_vm._s(_vm.inputTitle))]),
      _vm._v(" "),
      _c("span", { domProps: { innerHTML: _vm._s(_vm.inputBody) } }),
      _vm._v(" "),
      _c(
        "profile-form",
        {
          ref: "form",
          attrs: { endpoint: _vm.endpoint },
          on: {
            error: function ($event) {
              return _vm.$emit("done", $event)
            },
          },
        },
        [
          _c(
            "form",
            { staticClass: "form-hidden" },
            [
              _c("input", {
                attrs: {
                  name: _vm.field,
                  type: "hidden",
                  "data-field-type": "Hidden",
                  checked: "",
                  value: "true",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.needs, function (n) {
                return _c("input", {
                  key: n,
                  attrs: {
                    name: n,
                    type: "hidden",
                    checked: "",
                    value: "true",
                    "data-field-type": "Hidden",
                  },
                })
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }